export interface BatteryStatusReportArgs {
    CustomerID: number;
    LocationGroupID?: number;
    LocationID?: number[];
    Status?: string;
    IncludeInactiveLocations?: boolean;
    Sort: string;
    PageSize: number;
    StartPage: number;
    SearchValue: string;
}

export interface BatteryStatus {
    locationID: number;
    locationName: string;
    day: string;
    status: string;
    voltage: number;
    seriesName?: string;
}

export class BatteryStatusList {
    public batteryStatusList: Array<BatteryStatus>;
    public batteryGraphStatusList: Array<BatteryGraph>;
    public count: number;
}

export class BatteryGraph {
    public status: string;
    public count: number;
}

export enum BatteryStatusEnum {
    Good = 'GOOD',
    Low = 'LOW',
    Critical = 'CRITICAL'
}

export class BatteryStatusListResponse {
  listBatteries: ListBatteryResponse[]
  listBatteriesStatus: ListBatteriesStatusResponse[]
  count: number
}

export interface ListBatteryResponse {
  locationID: number
  locationName: string
  seriesName: string
  day: string
  status: string
  statusType: number
  voltage: number
}

export interface ListBatteriesStatusResponse {
  status: string
  count: number
}
